import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import useReviewSystemV3Experiment from '@src/quince-site-common/src/hooks/useReviewSystemV3Experiment'
import { IFilterProps } from '@src/quince-site-pdp/src/organisms/productPageSections/productReviews/types'
import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'

// Utils

import LoaderWrapper from '../../loaderWrapper'
import Pagination, { PaginationProps } from '../../pagination'
import { ReviewItem, ReviewItemProps } from '../reviewItem'

import styles from './allReviews.module.scss'
import { ReviewsFilter } from './ReviewsFilter'

export interface AllReviewsProps {
  reviews: ReviewItemProps[]
  paginationProps: PaginationProps
  className?: string
  filterProps: IFilterProps
  showReviewsLoader?: boolean
  onReviewImageClick: (reviewId: number, imageIndex: number) => void
  isKidsAndBabyProduct?: boolean
  variants?: any
  productProperties: ProductProperties
  newPdpv2?: boolean
  totalReviews: number
  reviewSystemExp: ReturnType<typeof useReviewSystemV3Experiment>
}

export const AllReviews = ({ className = '', reviewSystemExp, ...props }: AllReviewsProps) => {
  const { t } = useTranslation('common')
  const { deviceType } = useDeviceInfo()
  const isMobile = deviceType === DEVICE_TYPES.MOBILE
  // if (props.reviews.length <= 0) return <ReviewsFilter {...props.filterProps} />;

  return (
    <div className={classnames(styles.allReviewWrap, className, props.newPdpv2 && styles.allReviewWrap_newPdpDesignV2)}>
      <ReviewsFilter
        {...props.filterProps}
        variants={props.variants}
        productProperties={props.productProperties}
        newPdpv2={props.newPdpv2}
        totalReviews={props.totalReviews}
        reviewSystemExp={reviewSystemExp}
      />
      <LoaderWrapper showLoader={props.showReviewsLoader}>
        {props.filterProps.hasPhoto && props.reviews.length <= 0 ? (
          <div className={styles.allReviews__noPhotoReviewText}>{t('no_reviews_with_photos')}</div>
        ) : (
          <div
            className={classnames(styles.reviewInnerWrap, {
              [styles.reviewInnerWrap_newPdpv2 ?? '']: props.newPdpv2,
            })}
          >
            {(reviewSystemExp.showReviewSummary ||
              reviewSystemExp.showReviewFilterTags ||
              reviewSystemExp.showReviewSummaryAndFilterTags) &&
              !isMobile && (
                <div className={styles.reviewsCount}>
                  {props.totalReviews} {props.totalReviews === 1 ? t('review_lowercase') : t('reviews')}
                </div>
              )}
            {props.reviews.map((reviewItem: ReviewItemProps, index: number) => {
              return (
                <ReviewItem
                  key={index}
                  index={index + (props.paginationProps.page - 1) * 4}
                  {...reviewItem}
                  isKidsAndBabyProduct={props.isKidsAndBabyProduct}
                  onReviewImageClick={props.onReviewImageClick}
                  className={props.newPdpv2 ? styles.reviewItemWrap_newPdpv2 : ''}
                  newPdpv2={props.newPdpv2}
                />
              )
            })}
          </div>
        )}
      </LoaderWrapper>

      {props.reviews.length > 0 && <Pagination {...props.paginationProps} />}
    </div>
  )
}

export default AllReviews
